import { useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import { AnimatePresence, motion } from 'framer-motion';
import { WifiOff, Loader2 } from 'lucide-react';
import { useNetwork } from '@mantine/hooks';

import Logo from '@/shared/components/modules/Logo.jsx';
import logo from '@/assets/images/Logo.png';
import whiteLogo from '@/assets/images/WhiteLogo.png';

export default function OfflineOverlay() {
  const { online } = useNetwork();
  const isOnline = online ?? true;

  useEffect(() => {
    if (!isOnline) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOnline]);

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/70 text-gray-900 backdrop-blur-xl select-none dark:bg-[#111827]/80 dark:text-gray-100"
          dir="rtl"
        >
          <motion.div
            initial={{ scale: 0.95, y: 10, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            transition={{ delay: 0.15, duration: 0.4, ease: 'easeOut' }}
            className="flex w-full max-w-lg flex-col items-center px-6 text-center"
          >
            <div className="mb-10">
              {/* Logo Component */}
              <Logo
                src={logo}
                darkSrc={whiteLogo}
                alt="لوگو"
                imageClassName="h-14 w-auto object-contain transition-opacity duration-300 sm:h-16"
                draggable="false"
              />
            </div>

            <div className="relative mb-8 flex h-28 w-28 items-center justify-center rounded-full bg-[#C50F13]/10 dark:bg-[#C50F13]/20">
              <div
                className="absolute inset-0 animate-ping rounded-full bg-[#C50F13]/10 dark:bg-[#C50F13]/20"
                style={{ animationDuration: '3s' }}
              />
              <WifiOff
                size={48}
                strokeWidth={1.5}
                className="relative z-10 text-[#C50F13]"
              />
            </div>

            <div className="space-y-4">
              <h1 className="text-3xl font-black tracking-tight text-gray-900 sm:text-4xl dark:text-white">
                ارتباط قطع شد!
              </h1>
              <p className="mx-auto max-w-sm text-base leading-relaxed text-gray-500 dark:text-gray-400">
                به نظر می‌رسد اتصال اینترنت شما قطع شده است. لطفاً وضعیت شبکه
                خود را بررسی کنید. سیستم به صورت خودکار در حال تلاش مجدد است.
              </p>
            </div>

            <div className="mt-10 flex items-center gap-3 rounded-2xl bg-white px-5 py-3 shadow-sm ring-1 ring-gray-900/5 dark:bg-[#23294B]/50 dark:ring-white/10">
              <Loader2 className="h-5 w-5 animate-spin text-[#EF5926]" />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                در حال تلاش برای اتصال مجدد...
              </span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
